import React, { useEffect, useRef, useState } from "react";
import * as Shared from "../components/CivicShared";
const { api, copy, subCategories, wardPath, VIJAYANAGAR_WARDS, CIVIC_CATEGORIES, CIVIC_CATEGORIES_KN, Gate, SectionHeading, CivicStat, MiniAction, InfoCard, SimplePage, LocationPickerMap, Modal, FeedbackBox, NotFound, AlertCircle, ArrowLeft, ArrowRight, Bell, BriefcaseBusiness, Building2, Check, CheckCircle2, ChevronDown, Clock3, Eye, EyeOff, FileText, Globe2, HeartHandshake, Home, Lightbulb, LockKeyhole, LogIn, LogOut, Mail, MapPin, Menu, MessageCircle, MessageSquare, Phone, Search, ShieldCheck, Smartphone, UserCircle, UserRound, Users, X, MapContainer, TileLayer, useMapEvents } = Shared;

function MyReports({ user, t, onBack }) {
  const [reports, setReports] = useState([]);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/complaints/mine"),
      api.get("/notifications/mine"),
    ]).then(([a, b]) => {
      setReports(a.data);
      setNotifications(b.data);
    }).catch(() => {});
  }, []);

  return (
    <SimplePage title={t.myReports} onBack={onBack}>
      {notifications.length > 0 && (
        <section className="civic-data-panel">
          <h2><Bell size={18} /> Notifications</h2>
          {notifications.slice(0, 10).map((n) => (
            <div className="data-row" key={n.id}>
              <span>{n.title}</span>
              <small>{n.message}</small>
            </div>
          ))}
        </section>
      )}

      {reports.length === 0 ? (
        <div className="empty-panel">
          <FileText size={34} />
          <h2>No complaints yet</h2>
        </div>
      ) : (
        reports.map((r) => (
          <article className="resident-report civic-data-panel" key={r.tracking_id}>
            <div className="report-card-head">
              <div>
                <span className="tracking-label">{r.tracking_id}</span>
                <h3>{r.title}</h3>
              </div>
              <span className="status-badge">{r.status}</span>
            </div>

            <p>{r.description}</p>

            <div className="data-row">
              <span>Ward</span>
              <strong>{r.ward}</strong>
            </div>

            <div className="data-row">
              <span>Category</span>
              <strong>{r.category}</strong>
            </div>

            <div className="data-row">
              <span>Priority</span>
              <strong>{r.priority}</strong>
            </div>

            <div className="timeline-list">
              {(r.timeline || []).map((event, i) => (
                <div className="timeline-item" key={i}>
                  <CheckCircle2 size={15} />
                  <div>
                    <strong>{event.status}</strong>
                    <p>{event.note}</p>
                    <small>{event.at}</small>
                  </div>
                </div>
              ))}
            </div>
          </article>
        ))
      )}
    </SimplePage>
  );
}


export default MyReports;
